import React from "react";
import Nav from "react-bootstrap/Nav";
import TABS from "./dictionaries/tabs";
import NavItem from "./components/NavItem";
import URLS from "./dictionaries/urls";

const TabsReport = ({ data, onTabChange, children, dates }) => {
  const navProps = {
    variant: "tabs",
    defaultActiveKey: 0,
    onSelect: (key) => {
      onTabChange(key);
    },
    children: TABS.map((elm, i) => (
      <NavItem
        elm={elm}
        key={i}
        download={URLS[elm.key].download}
        dates={dates}
      />
    )),
  };

  return (
    <div className="col-12 col-md-8 col-lg-8">
      <Nav {...navProps} />
      {children}
    </div>
  );
};

export default TabsReport;
